import { AliasState } from '../../contexts/Alias/types';

const defaultAliasState: AliasState = {
  action: null,
  alias: null,
  selectedAccountForAction: null,
  onAccountSelectionForAction: () => {},
  onResetAccountSelectionForAction: () => {},
  onAliasAction: () => {},
  loadingState: {
    isLoadingUpsertAlias: false,
    isLoadingDeleteAlias: false,
  },
  errorState: {
    upsertAliasError: undefined,
    deleteAliasError: undefined,
  },
  upsertAliasData: null,
  deleteAliasData: null,
};

export { defaultAliasState };
